define((require) => {
    "use strict";

    const ImprovedView        = require("editor/zbone/ImprovedView");
    const template            = require("ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceQuickViewSettings.tpl");
    const SalesforceCommerce  = require("ui/experience/widgets/salesforceCommerceWidget/service/SalesforceCommerceConnect");

    /**
     * @class SalesforceCommerceQuickViewSettings
     *
     * The <i>SalesforceCommerce Quick settings</i> responsible to inform the user about the QuickView feature.
     */
    return ImprovedView.extend({
        template: template,

        templateHelpers() {
            return {
                isSalesforceCommerceEnabled: SalesforceCommerce.isQuickViewEnabled()
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceQuickViewSettings.js